import React from "react";

import { Line } from "./styles";

const Separator = () => {
    return <Line />;
};

export default Separator;
